export default {
  computed: {
    isMainDataIncorrect() {
      return !this.userData.name_ru.family_name_ru || !this.userData.name_ru.given_name_ru ||
        !this.userData.birthdate || !this.userData.birth_place_str || !this.userData.citizenship;
    }
  }
}